interface IParticipant {
  id?: string;
  activityOccurrenceId?: string;
  activityRegistrationId?: string;
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  allergies?: string;
  reducedMobility: boolean;
  memberNumber?: string;
  companyName?: string;
  organizationName?: string;
}

export class Participant implements IParticipant {
  id?: string;
  activityOccurrenceId?: string;
  activityRegistrationId?: string;
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  allergies?: string;
  reducedMobility = false;
  memberNumber?: string;
  companyName?: string;
  organizationName?: string;
}